  <!-- Frecce navigazione storie -->
  <button
    *ngIf="storyCount > 1"
    type="button"
    class="story-nav-arrow story-nav-arrow-left d-flex align-items-center justify-content-center"
    (click)="previousStory()">
    <i class="fas fa-chevron-left"></i>
  </button>

  <button
    *ngIf="storyCount > 1"
    type="button"
    class="story-nav-arrow story-nav-arrow-right d-flex align-items-center justify-content-center"
    (click)="nextStory()">
    <i class="fas fa-chevron-right"></i>
  </button>

<div 
  class="offer-modal-container position-relative w-100 h-100 text-white d-flex flex-column"
  [class.min-vh-100]="fullScreen"
  [class.story-image-mode]="isImageStory"
  [ngStyle]="{ 'min-height': isImageStory ? 'auto' : '500px' }">

  <!-- Header con Progress Bars -->
  <div 
    *ngIf="storyCount > 0" 
    class="progress-bars-container d-flex gap-1 p-3 position-absolute top-0 start-0 end-0" 
    style="z-index: 10; background: linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, transparent 100%);" 
    (click)="$event.stopPropagation()">
    <div 
      *ngFor="let progress of progressValues; let i = index" 
      class="progress-bar-wrapper"
      [style.width.%]="progressValues.length ? (100 / progressValues.length) : 100">
      <div class="progress" style="height: 3px; background-color: rgba(255, 255, 255, 0.3);">
        <div 
          class="progress-bar bg-light"
          role="progressbar"
          [style.width.%]="progressValues[i]"
          [attr.aria-valuenow]="progressValues[i]"
          aria-valuemin="0"
          aria-valuemax="100">
        </div>
      </div>
    </div>
  </div>

  <!-- Pulsante di chiusura - fuori dalle zone touch -->
  <div class="close-button-wrapper position-absolute top-0 end-0" style="z-index: 100;">
    <button 
      type="button" 
      class="btn-close btn-close-white m-3 opacity-75 transition-all" 
      aria-label="Close"
      (click)="closeModal(); $event.stopPropagation()"
      (touchstart)="onCloseButtonTouchStart($event)"
      (touchend)="onCloseButtonTouchEnd($event)">
    </button>
  </div>

  <!-- Zone touch per navigazione mobile -->
  <div 
    *ngIf="storyCount > 1"
    class="touch-navigation-zones position-absolute top-0 start-0 end-0 bottom-0"
    [class.has-cta]="currentStory?.ctaRoute"
    [style.z-index]="currentStory?.ctaRoute ? 25 : 2">
    <!-- Zona sinistra: previous story -->
    <div 
      class="touch-zone touch-zone-left"
      (click)="onTouchZoneClick($event, 'left')"
      (touchstart)="onTouchZoneStart($event, 'left')"
      (touchend)="onTouchZoneEnd($event, 'left')">
    </div>
    <!-- Zona centro: pausa (gestita dagli handler globali) - CTA quando c'è ctaRoute -->
    <div 
      class="touch-zone touch-zone-center"
      (click)="onCenterZoneClick($event)"
      (touchstart)="onCenterZoneTouchStart($event)"
      (touchend)="onCenterZoneTouch($event)">
    </div>
    <!-- Zona destra: next story -->
    <div 
      class="touch-zone touch-zone-right"
      (click)="onTouchZoneClick($event, 'right')"
      (touchstart)="onTouchZoneStart($event, 'right')"
      (touchend)="onTouchZoneEnd($event, 'right')">
    </div>
  </div>

  <!-- Contenuto del template corrente -->
  <div 
    class="template-content flex-fill d-flex overflow-auto"
    [class.align-items-center]="!isImageStory"
    [class.justify-content-center]="!isImageStory"
    [class.image-mode]="isImageStory"
    [class.has-cta]="currentStory?.ctaRoute"
    [style.z-index]="currentStory?.ctaRoute ? 20 : 1"
    [style.padding]="isImageStory ? '0' : '60px 20px 20px'">

    <ng-container *ngIf="currentStory as story; else noContent">
      <ng-container [ngSwitch]="story.type">
        <div 
          *ngSwitchCase="'image'"
          class="story-image-wrapper"
          [class.has-cta]="story.ctaRoute"
          (click)="onStoryImageClick($event)"
          (touchstart)="onStoryImageTouchStart($event)"
          (touchend)="onStoryImageTouch($event)">
          <img 
            class="story-image"
            [src]="resolveImagePath(story.imageSrc || '')"
            alt="Story image" />
        </div>
        <ng-container *ngSwitchCase="'template'">
          <ng-container *ngIf="story.template as activeTemplate">
            <ng-container *ngTemplateOutlet="activeTemplate"></ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-template #noContent>
  <div class="empty-story-content text-center text-white-50">
    <p>Nessun contenuto disponibile.</p>
  </div>
</ng-template>


